import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["labelText", "formikFieldNames", "isRecommended"];
import React from 'react';
import { Input, Dropdown } from '../';
import { PubDateLabel, PubDateMainInputArea, StyledPubDate } from '../styled';
import { monthFieldOptions, InputLabels } from './constants';
export var PubDate = function PubDate(_ref) {
  var labelText = _ref.labelText,
    formikFieldNames = _ref.formikFieldNames,
    _ref$isRecommended = _ref.isRecommended,
    isRecommended = _ref$isRecommended === void 0 ? true : _ref$isRecommended,
    rest = _objectWithoutProperties(_ref, _excluded);
  var PUB_DATE_LABEL_ID = "pubdate-label-".concat(labelText.replace(' ', '-').toLowerCase());
  return /*#__PURE__*/React.createElement(StyledPubDate, {
    "data-test": rest['data-test']
  }, /*#__PURE__*/React.createElement(PubDateLabel, {
    id: PUB_DATE_LABEL_ID
  }, labelText), /*#__PURE__*/React.createElement(PubDateMainInputArea, {
    "aria-labelledby": "pubdate-label"
  }, /*#__PURE__*/React.createElement(Input, {
    name: formikFieldNames[0],
    labelText: InputLabels.DAY,
    className: "pubdate-input",
    placeholder: "DD",
    validationType: "day"
  }), /*#__PURE__*/React.createElement(Dropdown, {
    name: formikFieldNames[1],
    labelText: InputLabels.MONTH,
    className: "pubdate-input",
    options: monthFieldOptions
  }), /*#__PURE__*/React.createElement(Input, {
    name: formikFieldNames[2],
    labelText: InputLabels.YEAR,
    className: "pubdate-input",
    isRecommended: isRecommended,
    validationType: "year",
    placeholder: "YYYY"
  })));
};